import { mybets, mytotalbets } from "../../js/api/myBets.js";
import { mybet } from "../../js/api/myBet.js";
import { _t } from "../../services/TranslationService.js";
import { generateRowView } from "../templates/mybetsrow.js";
import { getGamePrintDetails } from "../templates/print.js";

let MyBets = {
  render: async () => {
    $("#tblMyBets .singleBetTable").each(function (i, item) {
      let itemId = $(this).children(".singleBetHeader").attr("bet-id");
      let canCash = $(this).children(".singleBetHeader").attr("bet-can-cash");

      if ($(item).attr("cash-out-status") === "true" && canCash !== "0") {
        $(item).append(`
                    <div class="cashoutHolderBtn">
                        <a class="cashoutBtn" data-betId="${itemId}">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 64 80" style="enable-background:new 0 0 64 64;" xml:space="preserve"><rect x="13" y="59" width="22" height="2"/><path d="M43,40c0,0.5-0.5,1-1,1s-1,0.5-1,1s-0.5,1-1,1h-5v2h9c0.5,0,1-0.5,1-1V7h-2V40z"/><path d="M13.8,32.2c-0.5,1.3-0.7,2.6-0.4,3.9L17,53.9c0,0,0,0,0,0V57h14v-3.2l1.3-3.9c0.5-1.5,0.8-3,0.8-4.4V31.1  c0-1.1-0.9-2.2-2.1-2.1c-1.1,0-1.9,0.9-1.9,2l0,6.2c0,0.8-0.5,1.9-1.3,2.3C27,40,26.1,40,25.3,39.6l-7.9-4.7  C17.2,34.7,17,34.4,17,34v-9.2L13.8,32.2z M17.6,43c0.5-0.1,1.1,0.2,1.2,0.8l1.8,8c0.1,0.5-0.2,1.1-0.8,1.2c-0.1,0-0.9,0.3-1.2-0.8  l-1.8-8C16.7,43.7,17,43.2,17.6,43z"/><path d="M39.2,41c0.3-0.8,1-1.5,1.8-1.8V7H23v28.8l3.3,2c0.2,0.1,0.7,0.1,0.7-0.4V31c0-2.2,1.8-4,4-4s4,1.8,4,4v10H39.2z M39,36  c0,0.5-0.5,1-1,1s-1-0.5-1-1V26c0-0.5,0.5-1,1-1s1,0.5,1,1V36z M34,19c-0.5,0-1-0.5-1-1s0.5-1,1-1s1-0.5,1-1s-0.5-1-1-1s-1,0.5-1,1  c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H26c-0.5,0-1-0.5-1-1s0.5-1,1-1h1.2c0.4-1.2,1.5-2,2.8-2c0.5,0,1,0.5,1,1s-0.5,1-1,1  s-1,0.5-1,1s0.5,1,1,1s1-0.5,1-1c0-1.7,1.3-3,3-3c1.3,0,2.4,0.8,2.8,2H38c0.5,0,1,0.5,1,1s-0.5,1-1,1h-1.2C36.4,18.2,35.3,19,34,19z  "/><polygon points="19,7 19,33.4 21,34.6 21,7 "/><path d="M60.1,3H3.9C3.3,3,3,3.3,3,3.9v4.2C3,8.7,3.3,9,3.9,9H17V7h-3c-0.5,0-1-0.5-1-1s0.5-1,1-1h36c0.5,0,1,0.5,1,1s-0.5,1-1,1h-3  v2h13.1C60.7,9,61,8.5,61,8.1V3.9C61,3.3,60.5,3,60.1,3z M8,7H6C5.5,7,5,6.5,5,6s0.5-1,1-1h2c0.5,0,1,0.5,1,1S8.5,7,8,7z M58,7h-2  c-0.5,0-1-0.5-1-1s0.5-1,1-1h2c0.5,0,1,0.5,1,1S58.5,7,58,7z"/><path d="M55,19.6V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.8-1.1-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2c0,0,0.7,0.5,1.4,0l2-2  c0.4-0.4,0.4-1,0-1.4C55.9,18.5,55,19.6,55,19.6z"/><path d="M12.7,19.3c-0.9-0.8-1.7,0.3-1.7,0.3V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.9-1.2-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2  c0,0,0.7,0.4,1.4,0l2-2C13.1,20.3,13.1,19.7,12.7,19.3z"/></svg>
                            <span>Cash out</span>
                            <span id="${itemId}-cash-out-value"></span>
                        </a>
                    </div>
                `);
      }
    });

    let view = `
            <div class="w-full flex flex-row flex-wrap items-center justify-center">
                <div class="p-1 w-full flex flex-row flex-wrap">
                    <div class="w-full flex flex-row flex-wrap bg-black/40 space-x-2 items-center p-2 border-b border-[#3d3d3d]">
                        <a class="flex backBtn w-[24px] h-[24px] max-w-[calc(100%-24px)] border-r">
                            <svg class="py-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                        </a>
                        <span class="text-white text-center font-bold flex-1 text-[14px]">${_t(
                          "Bastet e mia "
                        )}</span>
                    </div>
                    <div class="flex flex-row flex-wrap w-full items-center bg-black/40 border-b border-[#3d3d3d] justify-center">
                        <div class="accountBalanceFilter flex flex-row flex-wrap space-x-2 items-center p-2 justify-center">
                            <span class="text-white text-[12px] text-center ">Filtro me date:</span>
                            <input type="text" readonly class="form-control text-[12px] p-1 bg-[#333] border-0 text-white cursor-pointer" class="form-control" id="myCalendar" />
                        </div>
                    </div>
                    <div class="bg-gradient-to-t from-[#232323] to-[#494949] w-full flex flex-wrap flex-row ${
                      role != "User" ? "agentColumn" : ""
                    }">
                        <div class="w-full flex flex-wrap flex-row p-4 items-center justify-center">
                            <div class="max-w-[840px] w-full">
                                <table id="betsTable" class="display w-full text-sm"></table>
                            </div>
                        </div>
                        <div id="myBetsFooter" class="myBetsFooter m-t-6 w-full bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md shadow-black font-bold text-[12px] leading-6 font-verdana text-white px-4"></div>

                        <div class="w-full flex flex-row flex-wrap w-full p-4" id="totalBetUsersInformation">

                        </div>
                    </div>
                </div>
            </div>
            <div class="cancelBtnMessageModal hidden">
                <p>${_t("Basti ka kaluar kohen e anulimit")}</p>
            </div>

            <div id="betModalDetail" class="-translate-x-full duration-0 ease-in-out pointer-events-none fixed bg-black/10 flex top-0 left-0 w-screen h-screen z-50 items-center flex-row flex-wrap justify-center">

            </div>
            
        `;
    return view;
  },
  after_render: async () => {
    let today = new Date();
    let todaySet = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    let startDate = today;
    let endDate = today;

    const currency = JSON.parse(localStorage.getItem("coins"));
    let mybetsprofile = await mybets(startDate, endDate, currency[0].id);
    let totalbetsprofile = await mytotalbets(startDate, endDate);

    if (totalbetsprofile.data) {
      // 1) extract and compute
      const d = totalbetsprofile.data;
      const stake = parseFloat(d.stake || 0).toFixed(2);
      const win = parseFloat(d.win || 0).toFixed(2);
      const diff = (parseFloat(d.stake || 0) - parseFloat(d.win || 0)).toFixed(
        2
      );
      const curr = (d.curr_name || "Euro").toUpperCase();

      // 2) prepare buckets
      let lek = { stake: "0.00", win: "0.00", diff: "0.00" };
      let euro = { ...lek };
      let dollar = { ...lek };

      // 3) assign into the right bucket
      switch (curr) {
        case "LEK":
          lek = { stake, win, diff };
          break;
        case "DOLLAR":
        case "USD":
          dollar = { stake, win, diff };
          break;
        default:
          euro = { stake, win, diff };
      }

      // 4) render both blocks
      $("body #totalBetUsersInformation").html(`
          <div class="max-w-[calc(100%-188px)] w-full flex flex-row flex-wrap mr-2 shadow-md shadow-black">
            <div class="bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md py-1 w-full flex justify-center text-white font-bold">
              <span class="text-[14px]">Informacion Monetar</span>
            </div>
            <div class="w-full py-4 px-2">
              <div class="grid grid-cols-4 text-right text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span></span>
                <span>Totali i Skedinave</span>
                <span>Totali i Fituar</span>
                <span>Diferenca</span>
              </div>
              <!-- LEK -->
              <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Leke</span>
                <span class="text-right px-1"><b>L ${parseFloat(
                  lek.stake
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>L ${parseFloat(
                  lek.win
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>L ${parseFloat(
                  lek.diff
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
              </div>
              <!-- EURO -->
              <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Euro</span>
                <span class="text-right px-1"><b>€ ${parseFloat(
                  euro.stake
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>€ ${parseFloat(
                  euro.win
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>€ ${parseFloat(
                  euro.diff
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
              </div>
              <!-- DOLLAR -->
              <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Dollare</span>
                <span class="text-right px-1"><b>$ ${parseFloat(
                  dollar.stake
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>$ ${parseFloat(
                  dollar.win
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
                <span class="text-right px-1"><b>$ ${parseFloat(
                  dollar.diff
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</b></span>
              </div>
            </div>
          </div>
      
          <div class="max-w-[180px] w-full flex flex-row flex-wrap shadow-md shadow-black">
            <div class="bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md py-1 w-full flex justify-center text-white font-bold">
              <span class="text-[12px]">Nr. Biletash</span>
            </div>
            <div class="w-full py-4 px-2">
              <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Fituese:</span>
                <span class="text-right px-1 text-[green]">${
                  d.won_bets || 0
                }</span>
              </div>
              <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Te djegura:</span>
                <span class="text-right px-1 text-[red]">${
                  d.lost_bets || 0
                }</span>
              </div>
              <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Ne Pritje:</span>
                <span class="text-right px-1">${d.open_bets || 0}</span>
              </div>
              <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
                <span class="text-left px-1">Totali</span>
                <span class="text-right px-1">${d.total_count || 0}</span>
              </div>
            </div>
          </div>
        `);
    }

    if ($.fn.DataTable.isDataTable("#betsTable")) {
      $("#betsTable").DataTable().clear().destroy();
    }
    $("#betsTable").DataTable({
      data: mybetsprofile,
      columns: [
        {
          title: "Nr.",
          data: "bet_number",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";
            return `<span class="${titleColor}">${data}</span>`;
          },
        },
        {
          title: "Operatori",
          data: "username",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";
            return `<span class="${titleColor}">${data}</span>`;
          },
        },
        {
          title: "Data",
          data: "created_at",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";

            const date = new Date(data);
            const pad = (n) => n.toString().padStart(2, "0");
            const formatted =
              `${pad(date.getDate())}/${pad(
                date.getMonth() + 1
              )}/${date.getFullYear()} ` +
              `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
                date.getSeconds()
              )}`;

            return `<span class="${titleColor}">${formatted}</span>`;
          },
        },
        {
          title: "Luajtur",
          data: "stake",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";
            return `<span class="${titleColor}">${parseFloat(
              data
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</span>`;
          },
        },
        {
          title: "Fitimi",
          data: "win",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";
            return `<span class="${titleColor}">${parseFloat(
              data
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</span>`;
          },
        },
        {
          title: "Valuta",
          data: "currency_name",
          render: function (data, type, row) {
            let titleColor =
              row.name.toLowerCase() === "won"
                ? "text-green-500"
                : row.name.toLowerCase() === "lost"
                ? "text-red-500"
                : "";
            return `<span class="${titleColor}">${data}</span>`;
          },
        },
        {
          title: "Detaje",
          data: null,
          render: function (data, type, row) {
            return `
                            <button class="view-btn bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)] text-white px-[10px] w-auto h-[30px] cursor-pointer leading-[30px] text-[12px] mr-2" data-id="${row.id}">View</button>
                        `;
          },
        },
      ],
      order: [[0, "desc"]],
      destroy: true,
      responsive: true,
      scrollCollapse: true,
      scrollY: "420px",
      lengthChange: false,
      info: false,
      language: {
        emptyTable: `<span class="w-full block text-center py-5 text-[14px]">Nuk ka të dhëna të disponueshme në tabelë</span>`,
      },
    });

    let isexecuted = 0;

    $("body").on("click", ".closeViewBet", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $("body #betModalDetail")
        .removeClass("translate-x-0 pointer-events-all")
        .addClass("-translate-x-full pointer-events-none");
      $("body #betModalDetail").html("");
    });

    $("body").on("click", ".view-btn", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (isexecuted) return;
      isexecuted = 1;

      let getmyBets = await mybet($(e.currentTarget).attr("data-id"));
      isexecuted = 0;

      let betView = generateRowView(
        getmyBets,
        $(e.currentTarget).attr("data-id")
      );

      $("body #betModalDetail").html(betView);
      $("body #betModalDetail")
        .removeClass("-translate-x-full pointer-events-none")
        .addClass("translate-x-0 pointer-events-all");
    });

    $("body").on("click", ".printTicket", async (e) => {
      let betId = $(e.currentTarget).attr("id");
      const userId = localStorage.getItem("user_id").toString();
      if (userId !== "38184") {
        const bet = await mybet(betId);
        const doc = getGamePrintDetails(bet);

        var printWin = window.open(
          "",
          "",
          "left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status  =0"
        );
        printWin.document.write(doc);
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.onafterprint = function () {
          printWin.close();
        };
      }
    });

    let months = [
      "Janar",
      "Shkurt",
      "Mars",
      "Prill",
      "Maj",
      "Qershor",
      "Korrik",
      "Gusht",
      "Shtator",
      "Tetor",
      "Nentor",
      "Dhjetor",
    ];
    let currentMonthDescription = `${months[todaySet.getMonth()]}`;

    let ranges = {
      Sot: [moment(), moment()],
      Dje: [moment().subtract(1, "days"), moment().subtract(1, "days")],
      2024: [moment().subtract(1, "year"), moment()],
      2025: [moment("01 Jan 2025"), moment()],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[
      `${months[todaySet.getMonth() == 0 ? 11 : todaySet.getMonth() - 1]}`
    ] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];
    $("#myCalendar").daterangepicker(
      {
        ranges: ranges,
        alwaysShowCalendars: true,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        opens: "center",
        locale: {
          direction: "ltr",
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: _t("Apliko"),
          cancelLabel: "Anulo",
          fromLabel: "Da",
          toLabel: "A",
          customRangeLabel: "Kostumizuar",
          daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
          monthNames: months,
          firstDay: 1,
        },
      },
      async function (start, end, label) {
        // show loader
        $("#contentLoader").append(`
          <div class="loaderWrapper">
            <div class="loader"></div>
          </div>
        `);

        // format dates
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");

        // fetch data
        const currency = JSON.parse(localStorage.getItem("coins") || "[]");
        const myBets = await mybets(startDate, endDate, currency[0]?.id);
        const totalBets = await mytotalbets(startDate, endDate);

        if (totalBets.data) {
          // helper: format numbers like 97,246.02
          const formatNumber = (value) =>
            Number(value || 0).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

          // compute values
          const d = totalBets.data;
          const stake = formatNumber(d.stake);
          const win = formatNumber(d.win);
          const diff = formatNumber(
            parseFloat(d.stake || 0) - parseFloat(d.win || 0)
          );
          const curr = (d.curr_name || "Euro").toUpperCase();

          // prepare buckets
          let lek = { stake: "0.00", win: "0.00", diff: "0.00" };
          let euro = { ...lek };
          let dollar = { ...lek };

          // assign to correct bucket
          switch (curr) {
            case "LEK":
              lek = { stake, win, diff };
              break;
            case "DOLLAR":
            case "USD":
              dollar = { stake, win, diff };
              break;
            default:
              euro = { stake, win, diff };
          }

          // render monetary info + ticket counts
          $("body #totalBetUsersInformation").html(`
    <div class="max-w-[calc(100%-188px)] w-full flex flex-row flex-wrap mr-2 shadow-md shadow-black">
        <div class="bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md shadow-black py-1 w-full flex justify-center text-white font-bold">
            <span class="text-[14px]">Informacion Monetar</span>
        </div>
        <div class="w-full py-4 px-2">
            <div class="grid grid-cols-4 text-right text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
              <span></span>
              <span>Totali i Skedinave</span>
              <span>Totali i Fituar</span>
              <span>Diferenca</span>
            </div>
            <!-- LEK row -->
            <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
              <span class="text-left px-1">Leke</span>
              <span class="text-right px-1"><b>L ${lek.stake}</b></span>
              <span class="currentBalanceNewLabel text-right px-1"><b>L ${
                lek.win
              }</b></span>
              <span class="text-right px-1"><b>L ${lek.diff}</b></span>
            </div>
            <!-- EURO row -->
            <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
              <span class="text-left px-1">Euro</span>
              <span class="text-right px-1"><b>€ ${euro.stake}</b></span>
              <span class="text-right px-1"><b>€ ${euro.win}</b></span>
              <span class="text-right px-1"><b>€ ${euro.diff}</b></span>
            </div>
            <!-- DOLLAR row -->
            <div class="grid grid-cols-4 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
              <span class="text-left px-1">Dollare</span>
              <span class="text-right px-1"><b>$ ${dollar.stake}</b></span>
              <span class="currentBalanceNewLabel text-right px-1"><b>$ ${
                dollar.win
              }</b></span>
              <span class="text-right px-1"><b>$ ${dollar.diff}</b></span>
            </div>
        </div>
    </div>

    <div class="max-w-[180px] w-full flex flex-row flex-wrap shadow-md shadow-black">
      <div class="bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019]
                  shadow-md shadow-black py-1 w-full flex justify-center text-white font-bold">
        <span class="text-[12px]">Nr. Biletash</span>
      </div>
      <div class="w-full py-4 px-2">
        <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
          <span class="text-left px-1">Fituese:</span>
          <span class="text-right px-1 text-[green]">${d.won_bets || 0}</span>
        </div>
        <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
          <span class="text-left px-1">Te djegura:</span>
          <span class="text-right px-1 text-[red]">${d.lost_bets || 0}</span>
        </div>
        <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
          <span class="text-left px-1">Ne Pritje:</span>
          <span class="text-right px-1">${d.open_bets || 0}</span>
        </div>
        <div class="grid grid-cols-2 text-white border-b border-dotted border-[#646464] py-1 text-[12px]">
          <span class="text-left px-1">Totali</span>
          <span class="text-right px-1">${d.total_count || 0}</span>
        </div>
      </div>
    </div>
  `);
        }

        // reinitialize DataTable
        if ($.fn.DataTable.isDataTable("#betsTable")) {
          $("#betsTable").DataTable().clear().destroy();
        }
        $("#betsTable").DataTable({
          data: myBets,
          columns: [
            {
              title: "Nr.",
              data: "bet_number",
              render: (data, type, row) => {
                const color =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";
                return `<span class="${color}">${data}</span>`;
              },
            },
            {
              title: "Operatori",
              data: "username",
              render: (data, type, row) => {
                const color =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";
                return `<span class="${color}">${data}</span>`;
              },
            },
            {
              title: "Data",
              data: "created_at",
              render: function (data, type, row) {
                let titleColor =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";

                const date = new Date(data);
                const pad = (n) => n.toString().padStart(2, "0");
                const formatted =
                  `${pad(date.getDate())}/${pad(
                    date.getMonth() + 1
                  )}/${date.getFullYear()} ` +
                  `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
                    date.getSeconds()
                  )}`;

                return `<span class="${titleColor}">${formatted}</span>`;
              },
            },
            {
              title: "Luajtur",
              data: "stake",
              render: (data, type, row) => {
                const color =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";
                return `<span class="${color}">${parseFloat(
                  data
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</span>`;
              },
            },
            {
              title: "Fitimi",
              data: "win",
              render: (data, type, row) => {
                const color =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";
                return `<span class="${color}">${parseFloat(
                  data
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</span>`;
              },
            },
            {
              title: "Valuta",
              data: "currency_name",
              render: (data, type, row) => {
                const color =
                  row.name.toLowerCase() === "won"
                    ? "text-green-500"
                    : row.name.toLowerCase() === "lost"
                    ? "text-red-500"
                    : "";
                return `<span class="${color}">${data}</span>`;
              },
            },
            {
              title: "Detaje",
              data: null,
              render: (data, type, row) => `
                <button class="view-btn bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)]
                               text-white px-[10px] w-auto h-[30px] cursor-pointer
                               leading-[30px] text-[12px] mr-2"
                        data-id="${row.id}">
                  View
                </button>`,
            },
          ],
          order: [[0, "desc"]],
          destroy: true,
          responsive: true,
          scrollCollapse: true,
          scrollY: "420px",
          lengthChange: false,
          info: false,
          language: {
            emptyTable: `<span class="w-full block text-center py-5 text-[14px]">
                           Nuk ka të dhëna të disponueshme në tabelë
                         </span>`,
          },
        });

        // remove loader
        $("body .loaderWrapper").remove();
      }
    );
  },
};

export default MyBets;
